import { emailApiClient } from './emailApiClient';

interface AttachmentResponse {
  url: string;
  fileName: string;
  contentType: string;
}

export const fetchAttachment = async (fileId: string, contactId: string): Promise<AttachmentResponse> => {
  const params = new URLSearchParams({ fileId, contactId });

  const response = await emailApiClient(`/attachment?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as {
    meta: { version: string };
    data: AttachmentResponse;
  };

  return json.data;
};
